import ChatComponent from "./components/ChatComponent";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ChatComponent />
    </div>
  );
}

export default App;
